import React, { useEffect, useState } from "react";
import PathIcon from "../../../../../../../Assets/Images/Wizard/your-path.svg";
import Line1 from "../../../../../../../Assets/Images/Wizard/line-1-left.svg";
import Line2 from "../../../../../../../Assets/Images/Wizard/line-2-left.svg";
import Line3 from "../../../../../../../Assets/Images/Wizard/line-3-left.svg";
import Line4 from "../../../../../../../Assets/Images/Wizard/line-4-left.svg";
import Select from "./IconSelect";
import Switch from "../../../../ShareElements/TextInput/Switch";

const Preferences = (props) => {
  const [PathItemIds] = useState(["career", "income", "projects", "skills"]);
  const [PreselectedLanguage, setPreSelectedLanguage] = useState();
  const [PreselectedCountry, setPreselectedCountry] = useState();

  useEffect(() => {
    handlePreSelectedPaths();
  }, []);

  useEffect(() => {
    handlePreSelectedCountry(props.Countries);
  }, [props.Countries]);

  useEffect(() => {
    if (props.Languages) {
      handlePreSelectedLanguage(props.Languages);
    }
  }, [props.Languages]);

  const translateText = (LabelId) => {
    // FIX: guard LangData before calling filter (same pattern as Bookmarks.js)
    if (!props.LangData || props.LangData.length === 0) return LabelId;
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0] ? Label[0].label_value : LabelId;
  };

  const handlePreSelectedPaths = () => {
    // FIX: guard against null path — use empty string as default
    let rawPath = props.UserInfo.path || "";
    let PreselectedPaths = rawPath.split(",");
    props.SavePathItems(PreselectedPaths);
    if (PreselectedPaths[0] !== "" && PreselectedPaths.length === 2) {
      PathItemIds.map((Path) => {
        const el = document.getElementById(Path);
        if (el) el.classList.add("disabled-path");
      });
    }
    PreselectedPaths.map((Id) => {
      if (document.getElementById(Id) !== null) {
        document.getElementById(Id).classList.remove("disabled-path");
        document.getElementById(Id).classList.add("active-path");
      }
    });
  };

  const handlePreSelectedLanguage = (Langs) => {
    let LangName;
    if (props.UserInfo.language === "EN") {
      LangName = "English";
    } else if (props.UserInfo.language === "DE") {
      LangName = "German";
    } else if (props.UserInfo.language === "FR") {
      LangName = "French";
    } else if (props.UserInfo.language === "ES") {
      LangName = "Spanish";
    }

    let SelectedLangObject;
    Langs.map((Item) => {
      if (Item.name === LangName) {
        SelectedLangObject = Item;
      }
    });
    setPreSelectedLanguage(SelectedLangObject);
  };

  const handlePreSelectedCountry = (CountryList) => {
    let SelectedCountry;
    CountryList.map((Item) => {
      if (Item.id === props.UserInfo.countryId) {
        SelectedCountry = Item;
      }
    });
    setPreselectedCountry(SelectedCountry);
  };

  const selectPathItem = (SelectedItem) => {
    let SelectedItems = [];
    if (
      !document.getElementById(SelectedItem).classList.contains("disabled-path")
    ) {
      window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false

      document.getElementById("path-error-text").style.display = "none";

      if (
        !document.getElementById(SelectedItem).classList.contains("active-path")
      ) {
        document.getElementById(SelectedItem).classList.add("active-path");
      } else {
        document.getElementById(SelectedItem).classList.remove("active-path");
      }

      PathItemIds.map((Path) => {
        if (document.getElementById(Path).classList.contains("active-path")) {
          SelectedItems.push(Path);
        }
      });
      if (SelectedItems.length >= 2) {
        props.SetHasMadeChanges(true);
        props.SetHasUnsavedChanges(true);
        let NonSelectedPaths = [];
        PathItemIds.map((Path) => {
          if (
            !document.getElementById(Path).classList.contains("active-path")
          ) {
            NonSelectedPaths.push(Path);
          }
        });
        NonSelectedPaths.map((Path) => {
          document.getElementById(Path).classList.add("disabled-path");
        });
      } else {
        props.SetHasMadeChanges(true);
        props.SetHasUnsavedChanges(true);
        let NonSelectedPaths = [];
        PathItemIds.map((Path) => {
          if (
            !document.getElementById(Path).classList.contains("active-path")
          ) {
            NonSelectedPaths.push(Path);
          }
        });
        NonSelectedPaths.map((Path) => {
          document.getElementById(Path).classList.remove("disabled-path");
        });
      }
    } else {
      document.getElementById("path-error-text").style.display = "block";
      setTimeout(() => {
        if (document.getElementById("path-error-text") !== null) {
          document.getElementById("path-error-text").style.display = "none";
        }
      }, 5000);
    }
    let ActivePaths = [];
    PathItemIds.map((Path) => {
      if (document.getElementById(Path).classList.contains("active-path")) {
        ActivePaths.push(Path);
      }
    });
    props.SavePathItems(ActivePaths);
  };

  const inputsChangeActions = () => {
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    props.SetHasMadeChanges(true);
    props.SetHasUnsavedChanges(true);
  };

  return (
    <div className="preferences">
      <div className="your-path">
        <h1 className="your-path-title">{translateText("wizard_your_path")}</h1>
        <p className="your-path-info">
          {translateText("wizard_ypur_path_info")}
        </p>
        <img className="your-path-icon" alt="" src={PathIcon} />
        <section className="path-options">
          <span
            className="path-option"
            id="career"
            onClick={() => selectPathItem("career")}
          >
            <div alt="" className="stroke-1" src={Line1}></div>
            {translateText("wizard_next_career")}
          </span>
          <span
            className="path-option"
            id="income"
            onClick={() => selectPathItem("income")}
          >
            <div alt="" className="stroke-2" src={Line2}></div>
            {translateText("wizard_improve_income")}
          </span>
          <span
            className="path-option"
            id="projects"
            onClick={() => selectPathItem("projects")}
          >
            <div alt="" className="stroke-3" src={Line3}></div>
            {translateText("wizard_cool_projects")}
          </span>
          <span
            className="path-option"
            id="skills"
            onClick={() => selectPathItem("skills")}
          >
            <div alt="" className="stroke-4" src={Line4}></div>
            {translateText("wizard_improve_skills")}
          </span>
          <p className="error-message" id="path-error-text">
            {translateText("wizard_path_validation_text")}
          </p>
        </section>
      </div>
      <section className="step-row">
        <p className="row-label">{translateText("system_language")}</p>
        {PreselectedLanguage ? (
          <Select
            Options={props.Languages}
            Label={PreselectedLanguage.name}
            PreselectedOption={PreselectedLanguage}
            IconClassName="feather-globe"
            Id="language"
            ChangeEvent={() => inputsChangeActions()}
          />
        ) : null}
      </section>
      <section className="step-row">
        <p className="row-label">
          {translateText("preferred_country_to_live_and_work")}
        </p>
        {PreselectedCountry ? (
          <Select
            Options={props.Countries}
            Label={PreselectedCountry.name}
            PreselectedOption={PreselectedCountry}
            IconClassName="feather-flag"
            Id="preferred-country"
            ChangeEvent={() => inputsChangeActions()}
          />
        ) : null}
      </section>
      <section className="step-row mobile-flex">
        <p className="row-label">{translateText("stay_anonymized")}</p>
        <Switch
          Id="anonymous"
          IsActive={props.UserInfo.anonymous}
          ChangeEvent={() => inputsChangeActions()}
        />
      </section>
    </div>
  );
};

export default Preferences;
